import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import AdminLayout from "../../masterLayout/AdminLayout";
import AdminPageHeader from "../../components/admin/AdminPageHeader";
import AdminDataTable from "../../components/admin/AdminDataTable";
import { adminApi, handleAdminLogoutIfNeeded } from "../../utils/adminApi";

const AdminPayments = () => {
  const [methods, setMethods] = useState([]);
  const [edit, setEdit] = useState(null);
  const [msg, setMsg] = useState("");

  const load = async () => {
    const res = await adminApi({
      url: "web/get-all-payment-method-admin",
      method: "GET",
    });
    if (handleAdminLogoutIfNeeded(res)) return;
    if (res.success) setMethods(res.data || []);
  };

  useEffect(() => {
    document.title = "Admin Payment Gateways";
    load().catch(console.error);
  }, []);

  const save = async (e) => {
    e.preventDefault();
    const res = await adminApi({
      url: "web/update-payment-method",
      method: "POST",
      body: {
        code: edit.code,
        active: edit.active ? 1 : 0,
        payment_id: edit.payment_id || "",
        payment_keys: edit.payment_keys || "",
      },
    });
    if (handleAdminLogoutIfNeeded(res)) return;
    setMsg(res.msg || (res.success ? "Updated" : "Failed"));
    if (res.success) {
      setEdit(null);
      load();
    }
  };

  const columns = [
    { key: "code", label: "Code" },
    {
      key: "active",
      label: "Active",
      render: (v) =>
        Number(v) === 1 ? (
          <span className="admin-chip">On</span>
        ) : (
          <span className="admin-chip off">Off</span>
        ),
    },
    {
      key: "payment_id",
      label: "Payment ID",
      render: (v) => (
        <span className="text-truncate d-inline-block" style={{ maxWidth: 180 }}>
          {v || "-"}
        </span>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (_, row) => (
        <button
          type="button"
          className="admin-btn admin-btn-ghost"
          style={{ minHeight: 34, padding: "0 10px" }}
          onClick={() =>
            setEdit({
              code: row.code,
              active: Number(row.active) === 1,
              payment_id: row.payment_id || "",
              payment_keys: row.payment_keys || "",
            })
          }
        >
          <Icon icon="lucide:pencil" width={16} />
        </button>
      ),
    },
  ];

  return (
    <AdminLayout>
      <div className="admin-ui">
        <AdminPageHeader
          title="Payment gateways"
          subtitle={`${methods.length} providers — toggle and configure keys.`}
        />
        {msg ? <div className="admin-alert admin-alert-info">{msg}</div> : null}

        {edit && (
          <div className="admin-form-card">
            <div className="admin-form-head">
              <h6>Edit gateway</h6>
              <p>Configure keys for <strong>{edit.code}</strong>.</p>
            </div>
            <form onSubmit={save}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Payment ID</label>
                  <input
                    className="form-control"
                    value={edit.payment_id}
                    onChange={(e) => setEdit({ ...edit, payment_id: e.target.value })}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Payment keys / secret</label>
                  <input
                    className="form-control"
                    value={edit.payment_keys}
                    onChange={(e) => setEdit({ ...edit, payment_keys: e.target.value })}
                  />
                </div>
                <div className="col-12">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="gw-active"
                      checked={!!edit.active}
                      onChange={(e) => setEdit({ ...edit, active: e.target.checked })}
                    />
                    <label className="form-check-label" htmlFor="gw-active">
                      Active
                    </label>
                  </div>
                </div>
              </div>
              <div className="admin-form-actions" style={{ marginTop: 16 }}>
                <button type="submit" className="admin-btn admin-btn-primary">Save</button>
                <button type="button" className="admin-btn admin-btn-ghost" onClick={() => setEdit(null)}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        <AdminDataTable columns={columns} rows={methods} />
      </div>
    </AdminLayout>
  );
};

export default AdminPayments;
